import { Grid, Box } from '@mui/material';
import { FormProvider, useForm } from 'react-hook-form';
import { RiLockPasswordFill } from 'react-icons/ri';
import { changePassword } from 'wisestep-api';
import { Item, WsButton, WsColors, WsIconText, WsTypography, WsTypoVariants } from 'wisestep-base';

import { useUserContext } from '../../../../context/UserContext';
import { success, failed, warning } from '../../../../utils/NotificationMessages';
import { useNotificationStore } from '../../../../utils/NotificationStore';
import RecruiterDetailsFields from '../RecruiterDetailsFields';

const SettingNewPassword = () => {
  const methods = useForm();
  const setNotification = useNotificationStore((state) => state.setNotification);
  const { handleSubmit } = methods;
  const loggedInUser = useUserContext().workspaceUser;
  const onFormSubmit = async (data) => {
    if (data.password == data.newPassword) {
      try {
        await changePassword(data.password);
        setNotification(success('Password changed successfully!'));
      } catch {
        setNotification(failed('Something went wrong!'));
      }
    } else setNotification(warning('Both passwords do not match!'));
  };

  return (
    <FormProvider {...methods}>
      <form onSubmit={handleSubmit(onFormSubmit)}>
        <Item sx={{ backgroundColor: WsColors.White }}>
          <Box>
            <Grid container pb={2}>
              <Grid item xs={11} pt={1} justifyContent="flex-start">
                <WsTypography variant={WsTypoVariants.TITLE}>
                  {`Update Password for [ ${loggedInUser?.login} ]`}
                </WsTypography>
              </Grid>
              <Grid item xs={1} justifyContent="flex-end">
                <WsButton size="large" type="submit">
                  Save
                </WsButton>
              </Grid>
            </Grid>
            <Grid container spacing={2} pt={2}>
              <Grid item xs={8} pb={2}>
                <RecruiterDetailsFields
                  name="password"
                  iconText={
                    <WsIconText
                      icon={<RiLockPasswordFill size={20} />}
                      text="New password"
                      textSize={WsTypoVariants.BODY1}
                    />
                  }
                  type="password"
                />
              </Grid>
              <Grid item xs={8} pb={2}>
                <RecruiterDetailsFields
                  name="newPassword"
                  iconText={
                    <WsIconText
                      icon={<RiLockPasswordFill size={20} />}
                      text="New password confirmation"
                      textSize={WsTypoVariants.BODY1}
                    />
                  }
                  type="password"
                />
              </Grid>
            </Grid>
          </Box>
        </Item>
      </form>
    </FormProvider>
  );
};

export default SettingNewPassword;
